import React, { useEffect, useState } from 'react';
import Icon from './forms/Icon';
import { useGlobalState } from './stateProvider/StateProvider';
import Col from './layout/Col';
import PageBreak from './layout/PageBreak';
import Input from './forms/Input';
import Img from './Img';
import Button from './forms/Button';
import RoleProtected, { userRoles } from './RoleProtected';
import Heading from './forms/Heading';
import HamQuest from './api/HamQuestGiver';
import { QuestRoute } from './api/QuestRoutes';
import ModalFactory from './Modal';
import Preput from './forms/Preput';
import styled from 'styled-components';

const Pre = styled.pre`
    font-family: inherit;
    margin: 0;
    white-space: pre-wrap;
    width: 100%;
`

export const EmbedVideo = ({ src, ...props }) => (
    <iframe
        width="560"
        height="315"
        src={src.replace('watch?v=', 'embed/')}
        frameBorder="0"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        style={{ maxWidth: '100%' }}
        {...props}
    />
)

const HelpDesk = ({ HSpage, ...props }) => {
    const {
        state: {
            pageInfo = {}
        },
        getPageInfo
    } = useGlobalState();

    const defaultPageHelp = {
        title: '',
        body: []
    }

    const [page, setPage] = useState('');
    const [pageHelp, setPageHelp] = useState({})

    useEffect(() => {
        setPage(HSpage || (window.location.pathname.replace('/', '')).replace(/\//g, '_'));
    }, [])

    useEffect(() => {
        setPageHelp(pageInfo[page])
    }, [page])

    if (!page) return;

    const Embed = ({ src, ...props }) => (
        <iframe
            width="560"
            height="315"
            src={src.replace('watch?v=', 'embed/')}
            frameborder="0"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            {...props}
        />
    )

    const showHelp = (info) => {
        ModalFactory.show({
            id: page,
            title: info.title,
            passthrough: true,
            body: (
                <PageBreak style={{ maxHeight: 'unset' }}>
                    {info.body.map((e, i) => (
                        <Col key={`pageHelp-${i}`} align='center'>
                            {e.heading && <Heading>{e.heading}</Heading>}
                            {e.text && <Pre>{e.text}</Pre>}
                            {e.image && <Img src={e.image} dim={15} style={{ width: '100%' }} />}
                            {e.video && <Col align='center'><Embed src={e.video} /></Col>}
                        </Col>
                    ))}
                </PageBreak>
            ),
            buttons: [
                <Button
                    label='Edit'
                    onClick={() => updateHelp(structuredClone(pageHelp))}
                    roles={userRoles.technicalInterfaceMaven}
                />
            ]
        })
    }

    const saveChanges = (title, body) => {
        ModalFactory.close(page);
        const temp = structuredClone(pageHelp || defaultPageHelp)
        temp.title = title;
        temp.body = body;
        setPageHelp(temp);

        HamQuest.post(QuestRoute.pageInfo, {
            page,
            title,
            body
        })
            .then(() => getPageInfo())
            .catch(ex => ModalFactory.catch(ex))
    }

    const updateHelp = (e) => {
        const Editable = ({ info = defaultPageHelp }) => {
            const { title, body } = info;
            const [_title, setTitle] = useState(title);
            const [inputs, setInputs] = useState([...body, { heading: '', text: '', image: '', video: '' }])

            const isNotEmpty = ({ heading, text, image, video }) => heading || text || image || video;

            const update = (key, index, value) => {
                let temp = [...inputs];
                temp[index][key] = value;
                temp = temp.filter(isNotEmpty);
                setInputs(
                    temp.length
                        ? isNotEmpty(temp[temp.length - 1])
                            ? [...temp, { heading: '', text: '', image: '', video: '' }] : temp
                        : [{ heading: '', text: '', image: '', video: '' }]
                );
            }

            return (
                <Col>
                    <PageBreak>
                        <Input
                            label='Title'
                            value={_title}
                            onInput={e => setTitle(e.target.value)}
                            standalone
                        />
                        {inputs.map((e, i) => (
                            <Col key={`pageHelp-${i}`}>
                                <Heading>Segment {i + 1}</Heading>
                                <Input
                                    label='Heading'
                                    name={`heading-${i}`}
                                    value={e.heading}
                                    onInput={(f) => update('heading', i, f.target.value)}
                                    standalone
                                />
                                <Preput
                                    label='Text'
                                    name={`text-${i}`}
                                    value={e.text}
                                    onInput={(f) => update('text', i, f.target.value)}
                                    standalone
                                />
                                <Input
                                    label='Image'
                                    name={`image-${i}`}
                                    value={e.image}
                                    onInput={(f) => update('image', i, f.target.value)}
                                    standalone
                                />
                                <Input
                                    label='Youtube Video'
                                    name={`video-${i}`}
                                    value={e.video}
                                    onInput={(f) => update('video', i, f.target.value)}
                                    standalone
                                />
                            </Col>
                        ))}
                    </PageBreak>
                    <Button
                        label='Save'
                        onClick={() => saveChanges(_title, inputs.filter(isNotEmpty))}
                    />
                </Col>
            )
        }

        if (pageHelp) {
            ModalFactory.update({
                id: page,
                title: 'Set Help',
                body: <Editable info={e} />
            })
        } else {
            ModalFactory.show({
                title: 'Set Help',
                body: <Editable info={e} />
            })
        }
    }

    return (pageHelp) ? (
        <Icon
            icon='questionMark'
            onClick={() => showHelp(structuredClone(pageHelp))}
            style={{ cursor: 'pointer' }}
        />
    ) : (
        <RoleProtected roles={userRoles.technicalInterfaceMaven}>
            <Icon
                icon='plus'
                onClick={() => updateHelp(structuredClone(pageHelp))}
                style={{ cursor: 'pointer' }}
            />
        </RoleProtected>
    );
}

export default HelpDesk;